// Based on: https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5

import { getTimer } from '@/common';

const easeInOutQuad = (
  time: number,
  startValue: number,
  change: number,
  duration: number,
) => {
  let time2 = time;
  time2 /= duration / 2;
  if (time2 < 1) return (change / 2) * time2 * time2 + startValue;
  time2 -= 1;
  return (-change / 2) * (time2 * (time2 - 2) - 1) + startValue;
};

export const animateScrollTo = async (element: HTMLElement, to: number, duration: number) => {
  const start = element.scrollTop;
  const change = to - start;
  const startDate = +new Date();

  const animateScroll = () => {
    const currentDate = Number(new Date());
    const currentTime = currentDate - startDate;
    element.scrollTop = parseInt(
      easeInOutQuad(currentTime, start, change, duration).toString(),
      10);
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      element.scrollTop = to;
    }
  };
  animateScroll();
  return await getTimer(duration);
};
